/* tslint:disable */
/* eslint-disable */
/**
 * topi Seller API
 * # Localization  Strings returned can be localized when the _Accept-Language_ header is provided in the request. It should follow the [RFC-2616 convention](http://www.ietf.org/rfc/rfc2616.txt).
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { PricingRequestFromJSON, PricingRequestToJSON, } from './PricingRequest';
/**
 * Check if a given object implements the ListRecommendedRentalPricesRequestBody interface.
 */
export function instanceOfListRecommendedRentalPricesRequestBody(value) {
    let isInstance = true;
    isInstance = isInstance && "pricingRequests" in value;
    return isInstance;
}
export function ListRecommendedRentalPricesRequestBodyFromJSON(json) {
    return ListRecommendedRentalPricesRequestBodyFromJSONTyped(json, false);
}
export function ListRecommendedRentalPricesRequestBodyFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'pricingRequests': (json['pricing_requests'].map(PricingRequestFromJSON)),
    };
}
export function ListRecommendedRentalPricesRequestBodyToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'pricing_requests': (value.pricingRequests.map(PricingRequestToJSON)),
    };
}
